import { motion } from "framer-motion";
import { CalendarClock } from "lucide-react";
import { CtaButton, WEBINARJAM_URL } from "./CtaButton";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="bg-sage">
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <p className="font-accent text-2xl sm:text-3xl text-cream/90 mb-4">so… you coming?</p>
        <h2 data-testid="final-cta-title" className="font-heading text-4xl sm:text-5xl tracking-tight text-white leading-tight">
          If you know you're called to create, this is a pretty good place to start.
        </h2>
        <div
          data-testid="final-cta-datetime"
          className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/30 px-4 py-2 text-sm text-cream"
        >
          <CalendarClock className="h-4 w-4" />
          Live · Tuesday, September 22 · 7:00 PM ET
        </div>
        <div className="mt-10">
          <a
            data-testid="final-cta-button"
            href={WEBINARJAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 rounded-full bg-cream px-10 py-4 text-base font-semibold text-sage transition-[transform,background-color] duration-300 hover:bg-white hover:scale-[1.03]"
          >
            Save My Free Seat
          </a>
          <p data-testid="final-cta-note" className="mt-4 text-sm text-cream/80">
            Takes less than a minute on WebinarJam.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
